<template>
  <b-row
    class="content-header"
  >
    <!-- Content Left -->
    <b-col
      class="content-header-left mb-2"
      cols="12"
      md="12"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="6">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $t('DEBTIA_VIEW_CASE') }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/cases">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item active>
                {{ caseID ? caseID : 'N/A' }} (BC-ID: {{ bcCaseId ? bcCaseId : 'N/A' }})
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-1 breadcrumbs-top">
        <b-col
          cols="12"
        >
          <b-overlay
            id="overlay-background-documents"
            :show="partnerLoader"
            variant="dark"
            opacity="0.85"
            blur="2px"
            rounded="sm"
            spinner-variant="primary"
            spinner-medium
          >
            <b-card
              class="mb-0 assignpartners-card"
            >
              <b-row>
                <b-col cols="12">
                  <v-select
                    id="notes-roles"
                    ref="assignPartnerSelect"
                    v-model="selectedPartners"
                    :class="!$ability.can(constants.action.permissionAssignPartner, constants.resource.user) ? 'disableAssignPartner': ''"
                    :options="partners"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :reduce="val => val.value"
                    multiple
                    label="label"
                    :disabled="!$ability.can(constants.action.permissionAssignPartner, constants.resource.user)"
                    @option:deselecting="deselectingOption"
                    @option:selecting="assignPartners"
                  />
                </b-col>
              </b-row>
            </b-card>
          </b-overlay>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BRow, BCol, BBreadcrumb, BBreadcrumbItem, // BFormGroup,
  BOverlay,
} from 'bootstrap-vue'
import axios from '@axios'
import i18n from '@/libs/i18n'
import constants from '@/app-configs/constants'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BBreadcrumb,
    BBreadcrumbItem,
    vSelect,
    // BFormGroup,
    BOverlay,
  },
  props: {
    bcCaseId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      caseID: this.$route.params.id,
      partners: [],
      selectedPartners: [],
      partnerLoader: true,
      originalSelection: [],
      constants,
    }
  },
  created() {
  },
  methods: {
    async fetchInitialData() {
      await this.getPartnersDropdown()
      await this.getCasePartners()
    },
    deselectingOption(option) {
      this.confirmAndRemove(option)
    },
    confirmAndRemove(item) {
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: `Are you sure to unassign ${item.label} from this case?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        const foundItem = this.originalSelection.find(element => element.partner_id === item.value)
        if (result.value) {
          if (foundItem) {
            this.unAssignPartner(item.value)
          }
          setTimeout(() => {
            this.$refs.assignPartnerSelect.open = false
          }, 300)
        } else {
          if (foundItem) this.getCasePartners()
          if (!foundItem) this.selectedPartners.push(item.value)
          setTimeout(() => {
            this.$refs.assignPartnerSelect.open = false
          }, 405)
        }
      })
    },
    async unAssignPartner(id) {
      this.partnerLoader = true
      await axios.post('/partners/debt-case/unassign', {
        debt_case_id: this.caseID,
        partner_id: id,
      }).then(response => {
        if (response.status === 200) {
          this.partnerLoader = false
          this.showComponentToast('Success', 'success', response.data.message)
          this.getCasePartners()
        }
      }).catch(error => {
        this.partnerLoader = false
        this.showComponentToast('Failed', 'warning', error.response.message)
      })
    },
    async getPartnersDropdown() {
      this.partnerLoader = true
      await axios.get('/partners?dropdown=true').then(response => {
        if (response.status === 200) {
          this.partnerLoader = false
          this.partners = response.data.data
        }
      })
    },
    async assignPartners(option) {
      this.selectedPartners.push(option.value)
      if (this.selectedPartners.length > 0) {
        this.partnerLoader = true
        await axios.post('/partners/debt-case/assign', {
          debt_case_id: this.caseID,
          partners: this.selectedPartners,
        }).then(response => {
          if (response.status === 200) {
            this.partnerLoader = false
            this.showComponentToast('Success', 'success', response.data.message)
            this.getCasePartners()
          }
        }).catch(error => {
          this.partnerLoader = false
          this.showComponentToast('Failed', 'warning', error.response.data.message)
        })
      } else {
        const msg = 'Select atleast one partner and then save.'
        this.showComponentToast('Failed', 'warning', msg)
      }
    },
    async getCasePartners() {
      this.partnerLoader = true
      await axios.get(`${constants.baseUrlV2}/debt-case/partners/${this.caseID}`).then(response => {
        if (response.status === 200) {
          this.partnerLoader = false
          if (response.data.data.partners.length > 0) {
            this.originalSelection = response.data.data.partners
            this.selectedPartners = this.originalSelection.map(partner => partner.partner_id)
          }
        }
      })
    },
    showComponentToast(title, variant, msg) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon: 'TwitchIcon',
          variant,
          text: msg,
        },
      })
    },
  },
}
</script>

<style lang="scss">
.disableAssignPartner span{
  color: rgb(162, 162, 162);
}

.disableAssignPartner span.vs__selected {border: 1px solid #219289;}
.assignpartners-card .card-body {
  padding: 10px;
}
</style>
